import { jsx as _jsx } from "react/jsx-runtime";
import { useFormContext } from 'react-hook-form';
import { Checkbox } from 'src/shared/components/form/checkbox';
import { useWeeklyStrategyItems } from './useWeeklyStrategyItems';
export function RepeatWeeklyStrategyForm() {
    const { watch, setValue } = useFormContext();
    const currentWeeklyStrategy = watch('recurringSession.repeat.weeklyStrategy');
    const weeklyStrategyItems = useWeeklyStrategyItems();
    function handleChange(value) {
        let newWeeklyStrategy = [];
        if (currentWeeklyStrategy.includes(value)) {
            newWeeklyStrategy = currentWeeklyStrategy.filter((weekday) => weekday != value);
        }
        else {
            newWeeklyStrategy = [...currentWeeklyStrategy, value];
        }
        setValue('recurringSession.repeat.weeklyStrategy', newWeeklyStrategy, {
            shouldValidate: true
        });
    }
    return (_jsx("div", { className: "flex flex-wrap items-center gap-x-5 gap-y-4", children: weeklyStrategyItems.map(({ label, value: weekday }) => (_jsx(Checkbox, { id: `mentorship-weekly-strategy-${weekday}`, label: label, value: weekday, onChange: () => handleChange(weekday) }, weekday))) }));
}
